export default "__VITE_ASSET__CaA1tZQJ__"